import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import mobilelogo from "../assets/images/sm-logo-trnspt-3.png";
import logo from "../assets/images/sm-logo-trnspt-3.png";
import supporticon from "../assets/icons/supporticon.svg";
import { Link, Route } from "react-router-dom";
import WidgetsIcon from "@mui/icons-material/Widgets";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Sidebar from "./Sidebar";
import VideoLibraryIcon from "@mui/icons-material/VideoLibrary";
import GroupIcon from "@mui/icons-material/Group";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Dropdown from "react-bootstrap/Dropdown";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChatIcon from "@mui/icons-material/Chat";
import Badge from "@mui/material/Badge";
import ReviewsIcon from "@mui/icons-material/Reviews";
import MailIcon from "@mui/icons-material/Mail";
import Tooltip from "@mui/material/Tooltip";
import BackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { AuthContext } from "../context/AuthContext";
import SearchCourses from "../actions/SearchCourses";
import Zoom from "@mui/material/Zoom";
import DetectDevice from "../data/DetectDevice";
import AccountOptionsDrowdown from "../pages/account/AccountOptionsDrowdown";
import ENDPOINT from "../data/ENDPOINT";
import Close from "@mui/icons-material/Close";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  ChevronLeft,
  ChevronLeftOutlined,
  ChevronRight,
  Edit,
  Home,
} from "@material-ui/icons";
import FeedIcon from "@mui/icons-material/Feed";
import ContactIcon from "@mui/icons-material/ContactPage";
import EventIcon from "@mui/icons-material/Event";
import WorkIcon from "@mui/icons-material/Work";
import DashboardIcon from "@mui/icons-material/Dashboard";
import axios from "axios";
import CallIcon from "@mui/icons-material/Call";
import accounticon from "../assets/sidebar/account.svg";
import homeicon from "../assets/sidebar/home.svg";
import internshipsicon from "../assets/sidebar/internships.svg";
import mycourseicon from "../assets/sidebar/my-course.svg";
import onlinetrainingicon from "../assets/sidebar/online-training.svg";
import offlinetrainingicon from "../assets/sidebar/offline-training.svg";
import privacyicon from "../assets/sidebar/privacy.svg";
import videosicon from "../assets/sidebar/videos.svg";
import workshopsicon from "../assets/sidebar/workshop.svg";
import featuresicon from "../assets/sidebar/advantage.svg";
import community from "../assets/sidebar/community.svg";
import dashboardicon from "../assets/icons/dashboard.svg";
import mycourse from "../assets/icons/my-courses.svg";
import reviewicon from "../assets/icons/review.svg";
import selfpacedicon from "../assets/icons/selfpaced-training.svg";
import termsicon from "../assets/icons/terms.svg";
import refundicon from "../assets/icons/refund.svg";
import shareicon from "../assets/icons/share-icon.svg";
import companyicon from "../assets/icons/company-icon.svg";
import freetrainingicon from "../assets/icons/free-training.svg";
import audio from "../assets/audio/notif.mp3";
import allcourses2 from "../assets/icons/all-courses2.svg";
import specializationicon from "../assets/icons/specialization.svg";
import NavbarCourseSearch from "./NavbarCourseSearch";
import { ref, push, onValue, getDatabase } from "firebase/database";
import SetPage from "../data/SetPage";
import UpdatingModal from "./modals/UpdatingModal";
import { useActionsContext } from "../context/ActionsContext";
import { ViewSidebarTwoTone } from "@mui/icons-material";
import LogoutIcon from "@mui/icons-material/Logout";
import LogoutModal from "./modals/LogoutModal";
import faqIcon from "./faq.png";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useDefaultContext } from "./context/DefaultContext";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const Navbar = ({ props, account, OpenSearch, fluid, secondaryview }) => {
  const { megaMenuDis, setMegaMenuDis } = useDefaultContext();
  const [canvas, setcanvas] = useState(false);
  const { user, cartCount, setCartCount } = useContext(AuthContext);
  const { search, ShowSearch, HideSearch, HideSidebar, ShowSidebar } =
    useActionsContext();
  const [loggedin, setloggedin] = useState(false);
  const history = useHistory();
  //  //console.log("navbar")
  const { sidebar, ToggleSidebar } = useActionsContext();
  const audioRef = React.createRef();
  const [secret, setsecret] = useState(
    JSON.parse(localStorage.getItem("uid")) || null,
  );
  const fetchCartCount = async () => {
    if (!user.SessionId) return;
    const data = new FormData();
    data.append("session", user.SessionId);
    const response = await axios.post(
      `${ENDPOINT}sell-tool-user-carts.php`,
      data,
      { header: { "content-type": "multipart/formdata" } },
    );
    if (response && response.data.status === "success") {
      const arr = Array.isArray(response.data.data) ? response.data.data : [];
      setCartCount(arr.length);
    }
  };

  useEffect(() => {
    setsecret(JSON.parse(localStorage.getItem("uid")));
  }, [JSON.parse(localStorage.getItem("uid")), secret]);
  const device = DetectDevice();
  useEffect(() => {
    if (user === null || user === "null") {
      setloggedin(false);
    } else {
      fetchCartCount();

      setloggedin(true);
    }
  }, []);

  const [title, settitle] = useState(null);

  const [page, setpage] = useState(sessionStorage.getItem("page"));
  useEffect(() => {
    setpage(sessionStorage.getItem("page"));
    JSON.parse(localStorage.getItem("uid"));
  }, [sessionStorage.getItem("page"), window.location.pathname]);

  React.useEffect(() => {
    const timer = setInterval(() => {
      settitle(JSON.parse(sessionStorage.getItem("page")));

      if (title === "Recordings") {
        setfullwidth(true);
      }
    }, 200);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const [results, setresults] = useState(null);

  const HiddenPages = ["Login", "Shorts", "shorts"];

  useEffect(() => {
    HideSearch();
    const sidebar = document.getElementById("sidebar");
    if (sidebar) {
      if (sidebar.classList.contains("display-sidebar")) {
        setcanvas(false);
      } else {
        setcanvas(false);
      }
    }
  }, [window.location]);
  const paramsfordis = useParams();
  useEffect(() => {
    setMegaMenuDis(false)
  }, [paramsfordis])
  const [notifications, setnotifications] = useState(null);
  const [unread, setunread] = useState(0);
  const [messages, setmessages] = useState(0);

  const GetNotifications = async () => {
    if (account) {
      try {
        fetch(`${ENDPOINT}get-notifications.php?session=${user.SessionId}`)
          .then((r) => r.json())
          .then((result) => {
            if (result[0].status === "success") {
              setunread(result[0].unread);

              if (unread !== parseInt(result[0].unread)) {
                //document.getElementById("audio").play()
              }

              setmessages(result[0].messages);

              if (result[0].data !== null) {
                setnotifications(result[0].data);
              }
            }
          });
      } catch { }
    }
  };

  const pathname = window.location.pathname;

  const updateActivity = async (status) => {
    const formData = new FormData();

    //formData.append('whyus',document.getElementById('whyus').value)
    if (user !== null) {
      formData.append("session", user.SessionId);
    } else {
      formData.append("secret", secret);
    }

    formData.append("page", pathname);

    formData.append("device", navigator.userAgent);

    const res = await axios.post(ENDPOINT + "save-activity.php", formData, {
      headers: {
        "content-type": "multipart/form-data",
      },
    });
    if (res) {
    }
  };

  const MakeTemporarySession = () => { };

  const CheckTempSession = () => {
    if (user === null || user === "null") {
      setloggedin(false);
    } else {
      setloggedin(true);
    }
  };

  useEffect(() => {
    updateActivity();
  }, [pathname]);

  useEffect(() => {
    HideSidebar();
  }, [window.location]);

  const dbRef = ref(
    getDatabase(),
    account ? account.user_id + "/notifications" : "anonymous",
  );

  useEffect(() => {
    // Listen for changes in the 'messages' node in the database
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const messageList = Object.values(data);
        if (account) {
          GetNotifications();
          console.log("retreving data");
        }
      }
    });
  }, [account]);

  const sendMessage = () => {
    // Push a new message to the 'messages' node in the database
    push(dbRef, {
      timestamp: new Date().getTime(),
    });
  };

  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (device === "mobile") {
    } else {
      const navbar2 = document.getElementById("navbar2");
      if (secondaryview) {
        if (visible && navbar2) {
          navbar2.classList.replace("hidenavbar2", "displaynavbar2");
        } else {
          if (navbar2) {
            navbar2.classList.replace("displaynavbar2", "hidenavbar2");
          }
        }
      } else {
        // navbar2.classList.add("hidenavbar2");
      }
    }
  }, [visible, secondaryview]);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      //console.log(currentScrollPos)
      setVisible(
        prevScrollPos > currentScrollPos ||
        prevScrollPos - currentScrollPos > 10,
      );

      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, visible]);

  const [fullwidth, setfullwidth] = useState(false);

  const [updatemodal, setupdatemodal] = useState(false);

  const CloseUpdateModal = () => {
    setupdatemodal(false);
  };

  const GoBack = () => {
    if (history.length > 0) {
      history.goBack();
    } else {
      history.replace("/");
    }
  };

  const [logoutmodal, setlogoutmodal] = useState(false);

  const CloseLogoutModal = () => {
    setlogoutmodal(false);
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(null);
  const [searchFocused, setSearchFocused] = useState(false);

  const handleSearchChange = async (e) => {
    const val = e.target.value;
    setSearchQuery(val);
    if (val.length > 2) {
      const res = await SearchCourses({
        payload: {
          category: "courses",
          limit: 6,
          search: val
        }
      });
      if (res && res.status === "success") {
        setSearchResults(res.data);
      }
    } else {
      setSearchResults(null);
    }
  };

  return (
    <>
      <style>
        {`
        /* ================= DESKTOP HEADER REDESIGN ================= */
        .main-header {
          background: #ffffff !important;
          padding: 8px 0 !important;
          transition: all 0.25s ease;
        }

        .navbar {
          background: #ffffff !important;
          backdrop-filter: none !important;
          -webkit-backdrop-filter: none !important;
          border-bottom: 2px solid #f15e22 !important;
          box-shadow: 0 4px 20px -10px rgba(0, 0, 0, 0.03) !important;
          height: 64px !important;
          padding: 0 5px !important;
          position: fixed !important;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 9999;
          transition: all 0.25s ease;
        }

        .primary-nav {
          height: 100% !important;
          padding: 0 !important;
        }

        /* Nav links & typography */
        .nav-items {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 24px !important;
          flex-grow: 1 !important;
        }

        .nav-item {
          text-decoration: none !important;
        }

        .nav-item p {
          color: #4b5563 !important;
          font-size: 13.5px !important;
          font-weight: 550 !important;
          transition: all 0.15s ease;
          letter-spacing: -0.01em;
          margin-bottom: 0 !important;
          position: relative;
          padding: 6px 0;
        }

        .nav-item:hover p {
          color: #2563eb !important;
        }

        .nav-item.active p {
          color: #2563eb !important;
          font-weight: 600 !important;
        }

        .nav-item.active p::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 0;
          width: 100%;
          height: 2px;
          background-color: #2563eb;
          border-radius: 99px;
        }

        .nav-item p svg {
          font-size: 16px !important;
          margin-left: 2px !important;
          color: #94a3b8 !important;
          transition: transform 0.2s ease;
        }

        .nav-dropdown:hover p svg {
          transform: rotate(180deg);
          color: #2563eb !important;
        }

        /* Explore button */
        .mega-menu-wrapper {
          margin-top: 0 !important;
        }

        .mega-menu-btn {
          background: #f15e22 !important;
          color: #ffffff !important;
          border: none !important;
          border-radius: 8px !important;
          padding: 8px 12px !important;
          height: 38px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          box-shadow: 0 4px 12px rgba(241, 94, 34, 0.15) !important;
          transition: all 0.15s ease !important;
        }

        .mega-menu-btn:hover {
          background: #d04a14 !important;
          transform: translateY(-0.5px);
        }

        .mega-menu-panel {
          background: #ffffff !important;
          border: 1px solid rgba(0, 0, 0, 0.06) !important;
          box-shadow: 0 20px 40px -10px rgba(0, 0, 0, 0.12) !important;
          border-radius: 12px !important;
          padding: 20px !important;
          top: 55px !important;
        }

        .mega-title {
          font-size: 12px !important;
          font-weight: 700 !important;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #9ca3af !important;
          margin-bottom: 10px !important;
        }

        .mega-link {
          color: #374151 !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          padding: 8px 10px !important;
          border-radius: 8px !important;
          transition: all 0.15s ease !important;
          gap: 12px !important;
          text-decoration: none !important;
          display: flex !important;
          align-items: center !important;
        }

        .mega-link:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          transform: translateX(2px) !important;
        }

        .mega-icon-box {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: rgba(241, 94, 34, 0.08) !important;
          color: #f15e22 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .mega-link:hover .mega-icon-box {
          background: rgba(241, 94, 34, 0.15) !important;
          color: #d04a14 !important;
        }

        .mega-icon {
          width: 16px !important;
          height: 16px !important;
          color: currentColor !important;
          transition: all 0.15s ease !important;
          flex-shrink: 0;
        }

        .mega-menu-content .col-lg-3:not(:last-child) {
          border-right: 1px solid #f3f4f6 !important;
        }

        /* Desktop Dropdowns (e.g. Courses, About) */
        .nav-dropdown {
          position: relative;
        }

        .nav-dropdown-content {
          opacity: 0;
          visibility: hidden;
          position: absolute;
          top: 100%;
          left: 0;
          transition: all 0.2s ease;
          transform: translateY(6px);
          z-index: 1000;
        }

        .nav-dropdown:hover .nav-dropdown-content {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }

        .nav-dropdown-main {
          background: #ffffff !important;
          border: 1px solid rgba(0, 0, 0, 0.08) !important;
          box-shadow: 0 15px 40px -10px rgba(0, 0, 0, 0.12) !important;
          border-radius: 16px !important;
        }

        .nav-dropdown-item {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          padding: 10px 12px !important;
          border-radius: 12px !important;
          transition: all 0.2s ease !important;
          text-decoration: none !important;
        }

        .nav-dropdown-item:hover {
          background: #f8fafc !important;
        }

        .dropdown-icon-box {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: rgba(241, 94, 34, 0.08) !important;
          color: #f15e22 !important;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .nav-dropdown-item:hover .dropdown-icon-box {
          background: rgba(241, 94, 34, 0.15) !important;
          color: #d04a14 !important;
        }

        .dropdown-item-title {
          font-size: 13.5px !important;
          font-weight: 650 !important;
          color: #0f172a !important;
          margin-bottom: 2px !important;
        }

        .dropdown-item-desc {
          font-size: 11px !important;
          font-weight: 450 !important;
          color: #64748b !important;
          white-space: normal !important;
          line-height: 1.3 !important;
        }

        .nav-dropdown-main .nav-item:hover svg {
          stroke: #2563eb !important;
        }

        /* Buttons & Actions */
        .btn-login {
          background: #f15e22 !important;
          color: #ffffff !important;
          border: 1px solid #f15e22 !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          padding: 8px 20px !important;
          border-radius: 99px !important;
          transition: all 0.15s ease !important;
          margin-left: 12px !important;
          text-decoration: none !important;
          box-shadow: 0 4px 12px rgba(241, 94, 34, 0.15) !important;
          display: inline-block !important;
        }

        .btn-login:hover {
          background: #d04a14 !important;
          border-color: #d04a14 !important;
          color: #ffffff !important;
          box-shadow: 0 6px 16px rgba(241, 94, 34, 0.25) !important;
          transform: translateY(-0.5px);
        }

        .btn-signup {
          background: #ffffff !important;
          color: #f15e22 !important;
          border: 1px solid #f15e22 !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          padding: 8px 20px !important;
          border-radius: 99px !important;
          transition: all 0.15s ease !important;
          margin-left: 12px !important;
          text-decoration: none !important;
          display: inline-block !important;
        }

        .btn-signup:hover {
          background: rgba(241, 94, 34, 0.05) !important;
          color: #d04a14 !important;
          border-color: #d04a14 !important;
          transform: translateY(-0.5px);
        }

        .sidebar-guest-btn {
          background: #f15e22 !important;
          color: #ffffff !important;
          border: 1px solid #f15e22 !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          padding: 8px 20px !important;
          border-radius: 99px !important;
          transition: all 0.15s ease !important;
          text-decoration: none !important;
          display: inline-block !important;
        }

        .sidebar-guest-btn:hover {
          background: #d04a14 !important;
          color: #ffffff !important;
          border-color: #d04a14 !important;
        }

        /* Search Box Desktop Reference Image Style */
        .course-search {
          background-color: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 99px !important;
          padding: 2px 14px !important;
          height: 38px !important;
          display: flex !important;
          align-items: center !important;
          box-shadow: none !important;
        }

        .course-search input {
          background: transparent !important;
          border: none !important;
          font-size: 13px !important;
          color: #1e293b !important;
          padding-left: 6px !important;
          outline: none !important;
        }

        .course-search svg {
          color: #94a3b8 !important;
          font-size: 18px !important;
        }

        /* Hamburger / Mobile Toggle */
        .btn-siloconMinds-orng {
          background: #ffffff !important;
          border: 1px solid #e5e7eb !important;
          color: #374151 !important;
          border-radius: 8px !important;
          padding: 6px 12px !important;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.15s ease !important;
        }

        .btn-siloconMinds-orng:hover {
          background: #f9fafb !important;
          color: #111827 !important;
          border-color: #d1d5db !important;
        }

        .btn-siloconMinds-orng svg {
          color: #4b5563 !important;
        }

        /* ================= MOBILE SIDEBAR REDESIGN ================= */
        .sidebar {
          background-color: rgba(17, 24, 39, 0.4) !important;
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          z-index: 999999 !important;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
        }

        .sidebar-content {
          background: #ffffff !important;
          width: 290px !important;
          height: 100% !important;
          box-shadow: 20px 0 50px -10px rgba(0, 0, 0, 0.15) !important;
          border-right: 1px solid rgba(0, 0, 0, 0.05) !important;
          display: flex !important;
          flex-direction: column !important;
          overflow: hidden !important;
          transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1) !important;
        }

        .sidebar-profile {
          background: #f9fafb !important;
          border-bottom: 1px solid #f3f4f6 !important;
          padding: 20px 16px !important;
        }

        .sidebar-profile h6 {
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #111827 !important;
          margin-bottom: 2px !important;
        }

        .sidebar-profile a {
          font-size: 12px !important;
          font-weight: 600 !important;
       
          text-decoration: none !important;
        }

        .sidebar-scroller {
          background-color: #ffffff !important;
          padding: 12px 10px !important;
          flex: 1 !important;
          overflow-y: auto !important;
        }

        .sidebar-item {
          border-left: 3px solid transparent !important;
          border-radius: 8px !important;
          padding: 10px 12px !important;
          margin-bottom: 4px !important;
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          background: transparent !important;
          transition: all 0.15s ease !important;
          text-decoration: none !important;
        }

        .sidebar-icon-wrapper {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background-color: rgba(241, 94, 34, 0.08) !important;
          transition: all 0.15s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .sidebar-item:hover .sidebar-icon-wrapper {
          background-color: rgba(241, 94, 34, 0.12) !important;
        }

        .sidebar-item.active .sidebar-icon-wrapper {
          background-color: rgba(241, 94, 34, 0.16) !important;
        }

        .sidebar-icon {
          width: 16px !important;
          height: 16px !important;
          color: #f15e22 !important;
          transition: all 0.15s ease !important;
        }

        .sidebar-item:hover .sidebar-icon {
          color: #d04a14 !important;
        }

        .sidebar-item.active .sidebar-icon {
          color: #d04a14 !important;
        }

        .sidebar-item p {
          margin: 0 !important;
          font-size: 13.5px !important;
          font-weight: 550 !important;
          color: #334155 !important;
          transition: all 0.15s ease !important;
        }

        .sidebar-item:hover {
          background: #f8fafc !important;
          border-left-color: #cbd5e1 !important;
        }

        .sidebar-item:hover p {
          color: #0f172a !important;
        }

        /* Active sidebar item style */
        .sidebar-item.active {
          background: rgba(241, 94, 34, 0.05) !important;
          border-left: 3px solid #f15e22 !important;
        }

        .sidebar-item.active p {
          color: #f15e22 !important;
          font-weight: 600 !important;
        }

        .sidebar-close {
          position: absolute !important;
          top: 16px !important;
          right: -42px !important;
          background: #ffffff !important;
          border: 1px solid #e5e7eb !important;
          box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;
          border-radius: 50% !important;
          width: 32px !important;
          height: 32px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          cursor: pointer !important;
          z-index: 100 !important;
          transition: all 0.15s ease !important;
        }

        .sidebar-close:hover {
          transform: scale(1.05);
          background: #f9fafb !important;
        }

        .sidebar-close svg {
          font-size: 16px !important;
          color: #4b5563 !important;
        }

        /* Settings and logout section */
        .sidebar-scroller hr {
          margin: 10px 0 !important;
          border-color: #f3f4f6 !important;
          opacity: 1 !important;
        }

        @media (max-width: 768px) {
          .navbar {
            height: 60px !important;
          }
          .primary-nav {
            padding: 0 !important;
            height: 100% !important;
          }
          .logo {
            height: 36px !important;
            max-height: 36px !important;
            width: auto !important;
            object-fit: contain !important;
            display: block !important;
          }
          .mobile-logo {
            height: 30px !important;
            max-height: 30px !important;
            width: auto !important;
            object-fit: contain !important;
            display: block !important;
          }
        }

        /* ===== HEADER RESPONSIVE FIXES (tablet & mobile) ===== */
        /* keep everything on ONE centered row below desktop; no overflow, no wrap */
        @media (max-width: 991px) {
          .primary-nav {
            flex-wrap: nowrap !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 8px !important;
          }
          .primary-nav > a { flex-shrink: 0 !important; line-height: 0 !important; }
          .nav-items { flex: 1 1 auto !important; min-width: 0 !important; }
          .header-actions {
            flex-shrink: 0 !important;
            margin-left: auto !important;
            align-items: center !important;
          }
          /* icon-only menu button (no text) */
          .header-menu-btn {
            width: 42px !important;
            min-width: 42px !important;
            height: 40px !important;
            padding: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
          }
          .header-menu-btn p { display: none !important; }
        }
        @media (max-width: 767px) {
          .navbar { height: 60px !important; padding: 0 8px !important; }
          .logo { height: 30px !important; margin-left: 8px !important; }
        }
        @media (max-width: 575px) {
          .logo { height: 28px !important; margin-left: 2px !important; }
          .header-actions { gap: 6px !important; }
        }
        `}
      </style>
      <LogoutModal visibility={logoutmodal} HandleClose={CloseLogoutModal} />

      <audio id="audio" src={audio} />
      <UpdatingModal visibility={updatemodal} HandleClose={CloseUpdateModal} />
      {HiddenPages.includes(title) ? (
        <></>
      ) : (
        <>
          <div className="main-header p-0  pb-md-4 pt-md-4">
            <div className="navbar container-fluid">
              <div
                className={
                  title === "Recordings" ? "container-fluid" : "container-fluid"
                }
              >
                <div className="primary-nav d-flex align-items-center pt-2 pb-2">
                  {device === "mobile" ? (
                    <>
                      {title === null ||
                        title === "null" ||
                        title === "Community" ? (
                        <>
                          {search ? (
                            <></>
                          ) : (
                            <>
                              <Link to="/">
                                <img
                                  src={mobilelogo}
                                  className="mobile-logo"
                                />
                              </Link>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {search ? (
                            <></>
                          ) : (
                            <>
                              <div
                                onClick={() => GoBack()}
                                type="button"
                                className="d-flex align-items-center"
                              >
                                <BackIcon className="text-dark fw-semibold" />
                                <h5 className="pb-0 ml-5 truncate truncate1 text-dark fw-semibold">
                                  {title}
                                </h5>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <Link to="/">
                        <img src={logo} className="logo ms-3" />
                      </Link>
                    </>
                  )}

                  <div className="nav-items d-md-flex align-items-center gap-4">
                    {/*NAV ITEMS*/}
                        <Link className="nav-item  d-lg-block d-none" to="/">
                          {/* <Home className="text-dark" /> */}
                          <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Home</p>
                        </Link>

                        {loggedin ? (
                          <>
                            {/* <Link
                        className="nav-item  d-lg-block d-none"
                        to="/newsfeed"
                      >
                        <FeedIcon />
                        <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Newsfeed</p>
                      </Link> */}
                          </>
                        ) : (
                          <></>
                        )}
                        {loggedin ? (
                          <>
                            <Link
                              className={
                                page === "Dashboard"
                                  ? "nav-item active text-light  d-lg-block d-none"
                                  : "nav-item  d-lg-block d-none"
                              }
                              to="/dashboard"
                            >
                              {/* <DashboardIcon className="text-dark" /> */}
                              <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Dashboard</p>
                            </Link>
                          </>
                        ) : null}
                        <Link
                          className="nav-item  d-lg-block d-none"
                          to="/courses"
                        >
                          <div className="nav-dropdown bg-transparent">
                            {/* <SchoolIcon className="text-dark" /> */}
                            <p className="fs-5 fw-semibold me-0 me-md-3 melg-4 d-flex align-items-center">Courses<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="dropdown-chevron ms-1"><polyline points="6 9 12 15 18 9"></polyline></svg></p>
                            <div className="nav-dropdown-content" style={{ left: "50%", transform: "translateX(-50%)" }}>
                              <div className="bg-white nav-dropdown-main shadow p-4 rounded-4" style={{ width: "660px" }}>
                                <div className="row g-3">
                                  {/* Item 1: Online Courses */}
                                  <div className="col-6">
                                    <Link to="/live-online-courses" className="nav-dropdown-item">
                                      <div className="dropdown-icon-box">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                      </div>
                                      <div className="overflow-hidden">
                                        <div className="dropdown-item-title">Online Courses</div>
                                        <div className="dropdown-item-desc">Live, instructor-led batches</div>
                                      </div>
                                    </Link>
                                  </div>

                                  {/* Item 2: Job Ready Courses */}
                                  {/* <div className="col-6">
                                    <Link to="/courses" className="nav-dropdown-item">
                                      <div className="dropdown-icon-box">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                                      </div>
                                      <div className="overflow-hidden">
                                        <div className="dropdown-item-title">Job Ready Courses</div>
                                        <div className="dropdown-item-desc">Deep dives into specific career paths</div>
                                      </div>
                                    </Link>
                                  </div> */}

                                  {/* Item 3: Offline Courses */}
                                  <div className="col-6">
                                    <Link to="/offline-courses" className="nav-dropdown-item">
                                      <div className="dropdown-icon-box">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line><line x1="9" y1="16" x2="15" y2="16"></line><path d="M8 6h2v2H8zM14 6h2v2h-2zM8 10h2v2H8zM14 10h2v2h-2z"></path></svg>
                                      </div>
                                      <div className="overflow-hidden">
                                        <div className="dropdown-item-title">Offline Courses</div>
                                        <div className="dropdown-item-desc">Classroom programs in our campuses</div>
                                      </div>
                                    </Link>
                                  </div>

                                  {/* Item 4: All Courses */}
                                  <div className="col-6">
                                    <Link to="/courses" className="nav-dropdown-item">
                                      <div className="dropdown-icon-box">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                                      </div>
                                      <div className="overflow-hidden">
                                        <div className="dropdown-item-title">All Courses</div>
                                        <div className="dropdown-item-desc">Browse the complete catalogue</div>
                                      </div>
                                    </Link>
                                  </div>

                                  {/* Item 5: Pre-Recorded Courses */}
                                  <div className="col-6">
                                    <Link to="/selfpaced-courses" className="nav-dropdown-item">
                                      <div className="dropdown-icon-box">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                                      </div>
                                      <div className="overflow-hidden">
                                        <div className="dropdown-item-title">Pre-Recorded Courses</div>
                                        <div className="dropdown-item-desc">Watch-anytime video lessons, lifetime access</div>
                                      </div>
                                    </Link>
                                  </div>

                                  {/* Item 6: Verify Certificate */}
                                  <div className="col-6">
                                    <Link to="/verify-certificate" className="nav-dropdown-item">
                                      <div className="dropdown-icon-box">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline></svg>
                                      </div>
                                      <div className="overflow-hidden">
                                        <div className="dropdown-item-title">Verify Certificate</div>
                                        <div className="dropdown-item-desc">Verify authenticity of student certificates</div>
                                      </div>
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>

                        <Link className="nav-item  d-lg-block d-none" to="/internship-programs">
                          {/* <Home className="text-dark" /> */}
                          <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Internships</p>
                        </Link>
                        

                        {/* <Link
                          className="nav-item d-lg-block d-none"
                          to="/interview-preparation"
                        >
                          <div className="nav-dropdown bg-transparent">
                            <SchoolIcon className="text-dark" />
                            <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Resources</p>
                            <div className="nav-dropdown-content p-3">
                              <div className="bg-white nav-dropdown-main shadow w-100 mt-10 p-3">
                                <div className="mb-2">
                                  <Link
                                    className="nav-item text-dark"
                                    to="/shorts"
                                  >
                                    Shorts
                                  </Link>
                                </div>

                                <div className="mb-2">
                                  <Link
                                    className="nav-item text-dark"
                                    to="/videos"
                                  >
                                    Videos
                                  </Link>
                                </div>
                                <div className="mb-2">
                            <Link className="nav-item text-dark" to="/notes">
                              Course Notes
                            </Link>
                          </div>
                                <div className="mb-2">
                                  <Link
                                    className="nav-item text-dark"
                                    to="/mock-tests"
                                  >
                                    Mock Tests
                                  </Link>
                                </div>
                                <div className="mb-2">
                                  <Link
                                    className="nav-item text-dark"
                                    to="/interview-preparation"
                                  >
                                    Interview Preparation Kits
                                  </Link>
                                </div>
                                <div className="mb-2">
                                  <Link
                                    className="nav-item text-dark"
                                    to="/technical-quizzes"
                                  >
                                    Quizzes
                                  </Link>
                                </div>

                                <div className="mb-2">
                                  <Link
                                    className="nav-item text-dark"
                                    to="/cheat-sheets"
                                  >
                                    Course Cheat Sheets
                                  </Link>
                                </div>
                                <div className="mb-2">
                            <Link
                              className="nav-item text-dark"
                              to="/free-resources"
                            >
                              Free Resources
                            </Link>
                          </div>
                              </div>
                            </div>
                          </div>
                        </Link> */}

                        <Link className="nav-item d-13k-none" to="/about">
                          <div className="nav-dropdown bg-transparent">
                            {/* <SchoolIcon className="text-dark" /> */}
                            <p className="fs-5 fw-semibold me-0 me-md-3 melg-4 px-0 d-flex align-items-center">About<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="dropdown-chevron ms-1"><polyline points="6 9 12 15 18 9"></polyline></svg></p>
                            <div className="nav-dropdown-content" style={{ left: "50%", transform: "translateX(-50%)" }}>
                              <div className="bg-white nav-dropdown-main shadow p-3 rounded-4" style={{ width: "320px" }}>
                                {/* Item 1: Student Reviews */}
                                <div className="mb-2">
                                  <Link to="/reviews" className="nav-dropdown-item">
                                    <div className="dropdown-icon-box">
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                                    </div>
                                    <div className="overflow-hidden">
                                      <div className="dropdown-item-title">Student Reviews</div>
                                      <div className="dropdown-item-desc">What our students say about us</div>
                                    </div>
                                  </Link>
                                </div>

                                {/* Item 2: About Company */}
                                <div className="mb-2">
                                  <Link to="/about" className="nav-dropdown-item">
                                    <div className="dropdown-icon-box">
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                    </div>
                                    <div className="overflow-hidden">
                                      <div className="dropdown-item-title">About Company</div>
                                      <div className="dropdown-item-desc">Our mission, vision, and team</div>
                                    </div>
                                  </Link>
                                </div>

                                {/* Item 3: Features */}
                                <div className="mb-2">
                                  <Link to="/features" className="nav-dropdown-item">
                                    <div className="dropdown-icon-box">
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                    </div>
                                    <div className="overflow-hidden">
                                      <div className="dropdown-item-title">Features</div>
                                      <div className="dropdown-item-desc">Unique learning methodologies</div>
                                    </div>
                                  </Link>
                                </div>

                                {/* Item 4: Contact Us */}
                                <div className="mb-2">
                                  <Link to="/contact" className="nav-dropdown-item">
                                    <div className="dropdown-icon-box">
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                                    </div>
                                    <div className="overflow-hidden">
                                      <div className="dropdown-item-title">Contact Us</div>
                                      <div className="dropdown-item-desc">Get in touch with support</div>
                                    </div>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Link>


                        {user ? (
                          <>
                            <Link
                              className="nav-item  d-lg-block d-none"
                              to="/recommendations"
                            >
                              {/* <GroupIcon className="text-dark" /> */}
                              <p className="fs-5 fw-semibold me-0 me-md-3 melg-4 text-dark">Connections</p>
                            </Link>
                          </>
                        ) : (
                          <>
                            {/* <Link
                              className="nav-item  d-lg-block d-none"
                              to="/videos"
                            >
                              <VideoLibraryIcon className="text-dark" />
                              <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Videos</p>
                            </Link> */}
                          </>
                        )}

                        <Link
                          className="nav-item  d-xl-block d-none"
                          to="/contact"
                        >
                          {/* <CallIcon className="text-dark" /> */}
                          <p className="fs-5 fw-semibold me-0 me-md-3 melg-4">Contact</p>
                        </Link>

                        {/*left toggle */}
                    {/*nav items*/}


                      {/* ===== MEGA MENU (desktop only) ===== */}
                      <div className="mega-menu-wrapper d-none d-lg-block ms-3 mt-1">
                        <button 
                          className="btn mega-menu-btn d-flex align-items-center justify-content-center gap-2" 
                          style={loggedin ? { width: "38px", padding: "8px" } : {}}
                          onClick={() => setMegaMenuDis(!megaMenuDis)} 
                          title="Explore"
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                          {!loggedin && <span className="fw-semibold text-white" style={{ fontSize: "14.5px" }}>Explore</span>}
                        </button>
                        {megaMenuDis ?
                          <div className="mega-menu-panel mx-auto">
                            <div className="mega-menu-content container-fluid">
                              <div className="row">

                                {/* COURSES */}
                                <div className="col-lg-3">
                                  <h6 className="mega-title">Courses</h6>

                                  <Link to="/online-courses" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                                    </div>
                                    Online Course
                                  </Link>

                                  <Link to="/offline-courses" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="9" y1="22" x2="9" y2="16"></line><line x1="15" y1="22" x2="15" y2="16"></line><line x1="9" y1="16" x2="15" y2="16"></line><path d="M8 6h2v2H8zM14 6h2v2h-2zM8 10h2v2H8zM14 10h2v2h-2z"></path></svg>
                                    </div>
                                    Offline Courses
                                  </Link>

                                  <Link to="/selfpaced-courses" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                                    </div>
                                    Pre Recorded Courses
                                  </Link>
                                </div>

                                {/* COMPANY */}
                                <div className="col-lg-3">
                                  <h6 className="mega-title">Company</h6>

                                  <Link to="/about" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                                    </div>
                                    About Us
                                  </Link>

                                  <Link to="/features" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon></svg>
                                    </div>
                                    Features
                                  </Link>

                                  <Link to="/internships" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                                    </div>
                                    Careers
                                  </Link>
                                </div>

                                {/* SUPPORT */}
                                <div className="col-lg-3">
                                  <h6 className="mega-title">Support</h6>

                                  <Link to="/faq" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                                    </div>
                                    FAQ
                                  </Link>

                                  <Link to="/privacy-policy" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                    <div className="mega-icon-box">
                                      <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                                    </div>
                                    Privacy Policy
                                  </Link>
                                </div>

                                {/* ACCOUNT */}
                                <div className="col-lg-3">
                                  <h6 className="mega-title">Account</h6>

                                  {account ? (
                                    <>
                                      <Link to="/dashboard" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                        <div className="mega-icon-box">
                                          <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="9" rx="1"></rect><rect x="14" y="3" width="7" height="5" rx="1"></rect><rect x="14" y="12" width="7" height="9" rx="1"></rect><rect x="3" y="16" width="7" height="5" rx="1"></rect></svg>
                                        </div>
                                        Dashboard
                                      </Link>

                                      <Link to="/my-courses" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                        <div className="mega-icon-box">
                                          <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
                                        </div>
                                        My Courses
                                      </Link>
                                    </>
                                  ) : (
                                    <Link to="/login" className="mega-link" onClick={() => setMegaMenuDis(false)} >
                                      <div className="mega-icon-box">
                                        <svg className="mega-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                      </div>
                                      Login / Signup
                                    </Link>
                                  )}
                                </div>

                              </div>
                            </div>
                          </div> : null}
                      </div>
                    </div>

                  {loggedin ? (
                    <>
                      <Stack
                        direction="row"
                        className="d-flex align-items-center header-actions"
                        spacing={1}
                      >
                        {account ? (
                          <>
                            <div className="d-block">
                              <AccountOptionsDrowdown account={account} />
                            </div>
                          </>
                        ) : null}

                        <div className="d-flex align-items-center">
                          <button
                            onClick={() => {
                              ToggleSidebar();
                            }}
                            aria-label="Open menu"
                            className="btn click d-block d-lg-none btn-siloconMinds-orng header-menu-btn"
                          >
                            <MenuIcon />
                          </button>
                        </div>
                      </Stack>
                    </>
                  ) : (
                    <div className="d-flex align-items-center ms-auto gap-2 header-actions">
                      <div className="d-flex align-items-center order-2">
                        <button
                          onClick={() => {
                            ToggleSidebar();
                          }}
                          aria-label="Open menu"
                          className="btn click d-block d-lg-none btn-siloconMinds-orng header-menu-btn"
                        >
                          <MenuIcon />
                        </button>

                      </div>
                      <div className=" d-none d-sm-flex align-items-center">
                        <Link
                          to="/login"
                          className="btn d-none d-sm-block btn-login"
                        >
                          Login
                        </Link>

                        <Link
                          to="/signup"
                          className="btn d-block d-sm-none btn-signup"
                        >
                          Login/SignUp
                        </Link>

                        <Link
                          to="/signup"
                          className="btn d-none d-sm-block btn-signup btn-siloconMinds-orng  "
                        >
                          SignUp
                        </Link>
                      </div>{" "}
                    </div>
                  )}
                </div>

                <div className="sec-nav"></div>
              </div>

              <div
                id="sidebar"
                onClick={ToggleSidebar}
                className="sidebar click hide-sidebar"
              >
                <div className="sidebar-content" onClick={(e) => e.stopPropagation()}>
                  {account ? (
                    <div className="sidebar-profile">
                      <div className="d-flex align-items-center gap-3">
                        <Avatar
                          src={account.profile_pic}
                          sx={{
                            width: 46,
                            height: 46,
                            border: "2px solid #f15e22",
                            bgcolor: "transparent"
                          }}
                        />
                        <div className="overflow-hidden">
                          <h6 className="mb-0 text-dark fw-bold text-truncate">
                            {account.first_name + " " + account.last_name}
                          </h6>
                          <Link className="text-decoration-none fw-semibold" to={"/edit-profile"} onClick={() => HideSidebar()}>
                            Edit Profile
                          </Link>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="sidebar-profile d-flex flex-column align-items-center text-center py-4 px-3">
                      <h6 className="mb-2 text-muted fw-normal">Welcome Guest</h6>
                      <Avatar
                        sx={{
                          width: 46,
                          height: 46,
                          border: "2px solid #f15e22",
                          bgcolor: "rgba(241, 94, 34, 0.08)",
                          color: "#f15e22",
                          margin: "8px 0"
                        }}
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                      </Avatar>
                      <Link 
                        to="/login" 
                        className="btn sidebar-guest-btn w-100 rounded-pill mt-2" 
                        onClick={() => HideSidebar()}
                      >
                        Login / Sign Up
                      </Link>
                    </div>
                  )}
                  <div onClick={HideSidebar} className="sidebar-close click">
                    <Close />
                  </div>

                  <div className="w-100 sidebar-scroller overflow-y" style={{ backgroundColor: "#ffffff" }}>
                    {account ? null : (
                      <Link
                        onClick={() => HideSidebar()}
                        className={`sidebar-item ${pathname === '/login' ? 'active' : ''}`}
                        to="/login"
                      >
                        <div className="sidebar-icon-wrapper">
                          <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                        </div>
                        <p>Login/Signup</p>
                      </Link>
                    )}

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/' ? 'active' : ''}`}
                      to="/"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                      </div>
                      <p>Home</p>
                    </Link>

                    {account && (
                      <>
                        <Link
                          onClick={() => HideSidebar()}
                          className={`sidebar-item ${pathname === '/dashboard' ? 'active' : ''}`}
                          to="/dashboard"
                        >
                          <div className="sidebar-icon-wrapper">
                            <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="9" rx="1"></rect><rect x="14" y="3" width="7" height="5" rx="1"></rect><rect x="14" y="12" width="7" height="9" rx="1"></rect><rect x="3" y="16" width="7" height="5" rx="1"></rect></svg>
                          </div>
                          <p>Dashboard</p>
                        </Link>

                        <Link
                          onClick={() => HideSidebar()}
                          className={`sidebar-item ${pathname === '/my-courses' ? 'active' : ''}`}
                          to="/my-courses"
                        >
                          <div className="sidebar-icon-wrapper">
                            <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path></svg>
                          </div>
                          <p>My Courses</p>
                        </Link>
                      </>
                    )}

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/offline-courses' ? 'active' : ''}`}
                      to="/offline-courses"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                      </div>
                      <p>Offline Courses</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/online-courses' || pathname === '/live-online-courses' ? 'active' : ''}`}
                      to="/online-courses"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>
                      </div>
                      <p>Online Courses</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/courses' ? 'active' : ''}`}
                      to="/courses"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path></svg>
                      </div>
                      <p>All Courses</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/selfpaced-courses' ? 'active' : ''}`}
                      to="/selfpaced-courses"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                      </div>
                      <p>Pre Recorded Courses</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname.startsWith('/internship') ? 'active' : ''}`}
                      to="/internships"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
                      </div>
                      <p>Internships</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/features' ? 'active' : ''}`}
                      to="/features"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                      </div>
                      <p>Training Features</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/faq' ? 'active' : ''}`}
                      to="/faq"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                      </div>
                      <p>FAQ</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/referral-program' ? 'active' : ''}`}
                      to="/referral-program"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line></svg>
                      </div>
                      <p>Refer & Earn</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/reviews' ? 'active' : ''}`}
                      to="/reviews"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                      </div>
                      <p>Students Reviews</p>
                    </Link>

                    <hr />

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/about' ? 'active' : ''}`}
                      to="/about"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                      </div>
                      <p>About Us</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/contact' ? 'active' : ''}`}
                      to="/contact"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                      </div>
                      <p>Contact Us</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/terms-and-conditions' ? 'active' : ''}`}
                      to="/terms-and-conditions"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                      </div>
                      <p>Terms & Conditions</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/privacy-policy' ? 'active' : ''}`}
                      to="/privacy-policy"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                      </div>
                      <p>Privacy Policy</p>
                    </Link>

                    <Link
                      onClick={() => HideSidebar()}
                      className={`sidebar-item ${pathname === '/refund-policy' ? 'active' : ''}`}
                      to="/refund-policy"
                    >
                      <div className="sidebar-icon-wrapper">
                        <svg className="sidebar-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21.5 2v6h-6M21.34 15.57a10 10 0 1 1-.57-8.38l5.67-5.67"></path></svg>
                      </div>
                      <p>Refund Policy</p>
                    </Link>

                    {account && (
                      <>
                        <hr />
                        <Link
                          onClick={() => {
                            HideSidebar();
                            setlogoutmodal(true);
                          }}
                          className="sidebar-item"
                        >
                          <svg className="sidebar-icon text-danger" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>
                          <p className="text-danger">LogOut</p>
                        </Link>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {device === "mobile" ? <></> : <></>}
          </div>
        </>
      )}
    </>

  );

};


export default Navbar;

const StyledNavbar = styled.div``;
